import axios from 'axios'
import config from '@/config.js'
import { getStatic, readOnlyError, staticKey } from '@/services/data-source.js'

const API_URL = config.apiUrl

const state = {
  siglesource: null,
  siglesources: [],
  siglesourcesUnion: {}
}

const mutations = {
  setSiglesource(state, siglesource){
    state.siglesource = siglesource
  },
  setSiglesources(state, siglesources){
    state.siglesources = siglesources
  },
  setSiglesourcesUnion(state, siglesourcesUnion){
    state.siglesourcesUnion = siglesourcesUnion
  }
}

const getters = {
}

const actions = {
  loadSiglesource({ commit }, code){
    const request = config.staticData
      ? getStatic(`siglesource/${staticKey(code)}.json`)
      : axios.get(`${API_URL}/siglesource/${encodeURIComponent(code)}`)
    return request
      .then(r => r.data)
      .then(siglesource => {
        commit('setSiglesource', siglesource)
        return siglesource
      })
  },
  loadSiglesources({ commit }){
    const request = config.staticData
      ? getStatic('siglesources.json')
      : axios.get(`${API_URL}/siglesources/all`)
    return request
      .then(r => r.data)
      .then(siglesources => {
        commit('setSiglesources', siglesources)
        return siglesources
      })
  },
  loadSiglesourcesUnion({ commit }){
    axios
      .get(`${API_URL}/siglesources/union`)
      .then(r => r.data)
      .then(siglesourcesUnion => {
        commit('setSiglesourcesUnion', siglesourcesUnion)
      })
  },
  saveSiglesource(_, siglesource){
    if (!config.editable) {
      return readOnlyError('Saving a sigle source')
    }
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/siglesource/${siglesource.code}`, siglesource)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  // createStudy(_, study){
  //   return new Promise((resolve) => {
  //     axios
  //       .post(`${API_URL}/study`, study)
  //       .then(response => {
  //         this.dispatch('addNotification', {
  //           type: 'success',
  //           text: `Study created`
  //         })
  //         resolve(response)
  //       })
  //       .catch(() => {
  //         this.dispatch('addNotification', {
  //           type: 'danger',
  //           text: `Something went wrong`
  //         })
  //       })
  //   })
  // },
  deleteSiglesource(_, siglesource){
    if (!config.editable) {
      return readOnlyError('Deleting a sigle source')
    }
    return new Promise((resolve) => {
      axios
        .delete(`${API_URL}/siglesource/${siglesource.code}`)
        .then(response => {
          this.dispatch('addNotification', {
            type: 'success',
            text: `Sigle source deleted`
          })
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
